module.exports = __webpack_public_path__ + "img/p22.19730369.png";